import React, { useRef } from "react";
import { Heading } from "iparque-components";
import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useOnScreen from "hooks/useOnScreen";
import { Container, Square } from "./styles";

interface Props {
  color: string;
  text: string;
  className?: string;
  textElementType?: string;
}

const intersectionOptions: IntersectionObserverOptions = {
  threshold: 1,
  unobserveOnIntersection: true,
};

const SquareHighlightText: React.FC<Props> = ({
  color,
  text,
  textElementType = "h2",
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(ref, intersectionOptions);

  return (
    <Container ref={ref} isVisible={isOnScreen} className={className}>
      <Square id="marked-text-square" color={color} />
      <div id="marked-text-text">
        <Heading variant="h9" elementType={textElementType} color="secondary">
          {text}
        </Heading>
      </div>
    </Container>
  );
};

export default SquareHighlightText;
